<template>
  <div class="form-page">
    <MyHeader />

    <div class="form-cont width1200">
      <div class="title">2021年掌上淄师新媒体纳新</div>
      <div class="des">
        竞聘成功感言每一次的竞聘对我来说都是一种学习,是经验的积累,也是提高
        自己、锻炼自己的一次机会。竞聘就像一面明镜,是给自己的一个挑
        战,也照耀出了自己到底有多少水平,看到不足和短处,让自已在以
        后的工作中及时填补上,同时也看到了自己和别的优秀人才的差距,
        督促自己以后要加强学习。
      </div>

      <div>
        <a-form :form="form" @submit="handleSubmit" class="form-box">
          <a-form-item v-bind="formItemLayout" label="姓名：">
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入姓名',
                    },
                  ],
                },
              ]"
              placeholder="请填写您的真实中文姓名"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="学号：">
            <a-input
              v-decorator="[
                'email12',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入学号',
                    },
                  ],
                },
              ]"
              placeholder="请输入您的学号"
            />
          </a-form-item>

          <a-form-item v-bind="formItemLayout" label="院系：" has-feedback>
            <a-select
              v-decorator="[
                'select',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择院系',
                    },
                  ],
                },
              ]"
              placeholder="选择院系"
            >
              <a-select-option value="china"> China </a-select-option>
              <a-select-option value="usa"> U.S.A </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            v-bind="formItemLayout"
            style="margin-bottom: 0px !important"
            label="个人照片："
          >
            <div class="ant-upload-text">上传个人照片限制58KB</div>
            <div class="clearfix">
              <a-upload
                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                list-type="picture-card"
                :file-list="fileList"
                @preview="handlePreview"
                @change="handleChange"
                v-decorator="[
                  '',
                  {
                    rules: [
                      {
                        required: false,
                        message: '请上传个人照片',
                      },
                    ],
                  },
                ]"
              >
                <div v-if="fileList.length < 8">
                  <a-icon type="camera" />
                </div>
                <p class="ant-upload-text">
                  重新上传
                </p>
              </a-upload>
              <a-modal
                :visible="previewVisible"
                :footer="null"
                @cancel="handleCancel"
              >
                <img alt="example" style="width: 100%" :src="previewImage" />
              </a-modal>
            </div>
          </a-form-item>

          <a-form-item v-bind="formItemLayout" label="个人特长：">
            <a-checkbox-group
              v-decorator="[
                'checkbox-group',
                {
                  initialValue: [],
                  rules: [
                    {
                      required: true,
                      message: '请选择个人特长',
                    },
                  ],
                },
              ]"
              style="width: 100%; margin-top: 8px"
            >
              <a-row>
                <a-col :span="3">
                  <a-checkbox value="A">唱歌 </a-checkbox>
                </a-col>
                <a-col :span="4">
                  <a-checkbox value="B">中国舞 </a-checkbox>
                </a-col>
                <a-col :span="3">
                  <a-checkbox value="C"> 街舞 </a-checkbox>
                </a-col>
                <a-col :span="3">
                  <a-checkbox value="C1"> 篮球 </a-checkbox>
                </a-col>
                <a-col :span="3">
                  <a-checkbox value="C2"> 滑板 </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="自我介绍：">
            <a-textarea
              placeholder="请输入一段文字简短的自我介绍"
              v-decorator="[
                'textarea',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入自我介绍',
                    },
                  ],
                },
              ]"
              :rows="5"
              :maxLength="200"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="上传作品：">
            <a-upload-dragger
              name="file"
              :multiple="true"
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              @change="handleChange"
              v-decorator="[
                'fileList1',
                {
                  rules: [
                    {
                      required: true,
                      message: '请上传作品',
                    },
                  ],
                },
              ]"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="camera" />
              </p>
              <p class="ant-upload-text">
                点击上传图片视频或附件拖至此处 限制10MB
              </p>
            </a-upload-dragger>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="备注：">
            <a-input v-decorator="['email1']" placeholder="可选填" />
          </a-form-item>
          <a-form-item v-bind="tailFormItemLayout">
            <a-button class="subs" type="picture-card" html-type="submit">
              提交报名
            </a-button>
          </a-form-item>

          <a-form-item v-bind="tailFormItemLayout">
            <div class="message-gs">©版权所有 淄博师专新媒体中心</div>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
// @ is an alias to /src
import MyHeader from "@/components/MyHeader.vue";

export default {
  name: "about",
  data() {
    return {
      confirmDirty: false,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
      previewVisible: false,
      previewImage: "",
      fileList: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "register" });
  },
  methods: {
    handleChange(info) {
      const status = info.file.status;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("Two passwords that you enter is inconsistent!");
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    },
    handleWebsiteChange(value) {
      let autoCompleteResult;
      if (!value) {
        autoCompleteResult = [];
      } else {
        autoCompleteResult = [".com", ".org", ".net"].map(
          (domain) => `${value}${domain}`
        );
      }
      this.autoCompleteResult = autoCompleteResult;
    },
  },
  components: {
    MyHeader,
  },
};
</script>


<style lang="less" scoped src="../assets/common.less">
</style>
<style scoped lang="less">
.form-box {
  /deep/ .ant-select-selection__placeholder {
    color: #000000;
    text-align: right;
  }
  // /deep/ .ant-upload-list-picture-card-container {
  //   float: right !important;
  // }
  // .ant-upload-picture-card-wrapper {
  //   width: 41%;
  // }
  // /deep/ .ant-upload-drag {
  //   width: 50%;
  //   // float: left;
  //   z-index: 999;
  //   // overflow: hidden;
  // }
  //   /deep/ .ant-upload-list-item{
  //   // float: left;
  //   // width: 50%;
  //   // line-height: 150px;
  //   // height: 150px;
  // }
}

.subs {
  width: 276px;
  height: 48px;
  background-image: linear-gradient(159deg, #ff5252 0%, #d52929 100%);
  border-radius: 100px;
  margin: 0 auto;
  border: none;
  font-size: 24px;
  color: #ffffff;
  margin-top: 10px;
  font-weight: 400;
}
.form-page {
  .form-cont {
    background-color: #fff;
    .title {
      font-size: 24px;
      color: #2a2a2a;
      letter-spacing: 0;
      font-weight: 600;
      padding-top: 32px;
      text-align: center;
      margin-bottom: 12px;
    }
    .des {
      width: 1100px;
      font-size: 14px;
      color: #777777;
      line-height: 20px;
      font-weight: 400;
      margin-bottom: 20px;
      margin: 0 auto;
    }
  }
}
.message-gs {
  margin-top: 40px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 12px;
  font-weight: 400;
  padding-left: 20px;
  padding-bottom: 30px;
}
.form-box {
  width: 70%;
  margin: 0 auto;
  margin-top: 40px;
}
</style>
